"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var color = function (value) { return "color: " + value + ";"; };
exports.default = (function (_a) {
    var warning = _a.warning, success = _a.success, error = _a.error;
    return function (_a) {
        var theme = _a.theme;
        if (warning || success || error) {
            return color(theme.palette.bannerTextColor[1]);
        }
        return color(theme.palette.bannerTextColor[0]);
    };
});
